import React from 'react';
import __ from 'lodash';

class DropdownTipeSoal extends React.Component{
    render(){
        return (
            this.props.tipeSoal.map((val) =>
                <option key={val.tipeSoal} value={val.tipeSoal}>{val.keterangan}</option>
            )            
        )
    }
}

export default DropdownTipeSoal;